import { StoreUser } from './models/store-user';

export type UsersState = {
  users: {
    [userId: number]: StoreUser;
  };
};

export const initialUsersState: UsersState = {
  users: {},
};
